var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-sign-in"},[_c('v-btn',{ref:"googleButton",attrs:{"outlined":""},on:{"click":_vm.googleLogin}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-google")]),_vm._v("Google ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }